export default "__VITE_ASSET__B$4nu8ji__"